import React, { Children } from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { AdvertisersByProductPageCache } from '../models/interfaces/PageCache';

const GET_ADVERTISERS_BY_POINTS_PAGE_CACHE = gql`
  query GetAdvertisersByPointsPageCache {
    advertisersByPointsPageCache @client {
      from
      size
      sortOptions {
        name
        tgrams_id
        campaigns
      }
      activeSort {
        sortKey
        sortDirection
      }
      searchTerm
      preSearchTerm
    }
  }
`;

interface AdvertisersByPointsPageCacheContainerProps {
  children: (props: any) => any;
}

interface AdvertisersByPointsPageCacheQueryResults {
  advertisersByPointsPageCache: AdvertisersByProductPageCache;
}
// class AdvertisersByPointsPageCacheQuery extends Query<AdvertisersByPointsPageCacheQueryResults> {}

const AdvertisersByPointsPageCacheContainer: React.FunctionComponent<
  AdvertisersByPointsPageCacheContainerProps
> = ({ children }) => {
  return (
    <Query<AdvertisersByPointsPageCacheQueryResults> query={GET_ADVERTISERS_BY_POINTS_PAGE_CACHE}>
      {({
        data: { advertisersByPointsPageCache } = { advertisersByPointsPageCache: {} },
        loading,
        error,
        client
      }) => {
        return children({
          loading,
          error,
          advertisersByPointsPageCache,
          updateAdvertiserPointsPage: async (from, size) => {
            const data = {
              advertisersByPointsPageCache: {
                from,
                size
              }
            };
            await client.writeData({ data });
          },
          updateCache: async (data: any) => {
            await client.writeData({ data });
          },
          client
        });
      }}
    </Query>
  );
};

export default AdvertisersByPointsPageCacheContainer;
